import React from 'react';

const navItems = [
  { label: 'Workspace', href: '/workspace', icon: <span role="img" aria-label="workspace">🛠️</span> },
  { label: 'Redeem Codes', href: '/admin/redeem-codes', icon: <span role="img" aria-label="redeem">🔑</span> },
  { label: 'Photo Sessions', href: '/admin/photo-sessions', icon: <span role="img" aria-label="photo">📸</span> },
];

const pastelBg = [
  'linear-gradient(90deg, #ccb4d6 0%, #b4e7f8 100%)',
  'linear-gradient(90deg, #f8e1f4 0%, #e1f8d6 100%)',
  'linear-gradient(90deg, #f8b4c4 0%, #f8e7b4 100%)',
];

export default function AdminNavBar({ active }) {
  return (
    <nav style={{
      width: '100%',
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      gap: 0,
      padding: '0 0 32px 0',
      background: 'transparent',
      zIndex: 10,
    }}>
      <div style={{ display: 'flex', gap: 18, marginRight: 32 }}>
        {navItems.map((item, idx) => (
          <a
            key={item.href}
            href={item.href}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              padding: '10px 28px',
              borderRadius: 999,
              background: pastelBg[idx % pastelBg.length],
              color: '#7c5fa6',
              fontWeight: 700,
              fontSize: 18,
              textDecoration: 'none',
              boxShadow: '0 2px 12px #ccb4d633',
              border: active === item.href ? '2px solid #a28ad6' : '2px solid transparent',
              transition: 'all 0.18s cubic-bezier(.4,2,.6,1)',
              transform: 'scale(1)',
            }}
            onMouseOver={e => {
              e.currentTarget.style.transform = 'scale(1.07)';
              e.currentTarget.style.boxShadow = '0 4px 18px #ccb4d699';
              e.currentTarget.style.background = pastelBg[(idx+1)%pastelBg.length];
            }}
            onMouseOut={e => {
              e.currentTarget.style.transform = 'scale(1)';
              e.currentTarget.style.boxShadow = '0 2px 12px #ccb4d633';
              e.currentTarget.style.background = pastelBg[idx % pastelBg.length];
            }}
          >
            {item.icon}
            <span>{item.label}</span>
          </a>
        ))}
      </div>
    </nav>
  );
}
